// extracted by mini-css-extract-plugin
module.exports = {"home-battery-C":"C_home-battery-C__Pu0l7"};